import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { notifyAuthChange } from '../hooks/useAuth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent duplicate processing (especially in StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Session ID manquant');
          navigate(location.pathname === '/dashboard' ? '/login' : '/connexion');
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for session_token
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: {
            'X-Session-ID': sessionId
          },
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Session exchange failed');
        }

        const data = await response.json();
        
        // Clear URL fragment
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        
        // Return to the page that initiated the login (admin -> /dashboard, client -> /mon-espace...)
        const target = location.pathname === '/dashboard' && !data.user.is_admin ? '/mon-espace' : location.pathname + location.search;
        notifyAuthChange(data.user);
        navigate(target, {
          state: { user: data.user },
          replace: true
        });
        
        toast.success(`Bienvenue ${data.user.name} !`);
        
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Erreur d\'authentification');
        navigate(location.pathname === '/dashboard' ? '/login' : '/connexion');
      }
    };

    processSession();
  }, []); // Empty deps - only run once on mount

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-gold border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg">Authentification en cours...</p>
      </div>
    </div>
  );
};
